import './style.styl'

import { RxConversationAPI } from '@driftt/dapper'
import { InlineWarning } from '@driftt/tide-core-legacy'
import { APP_URL } from 'constants/ResourcesConstants'
import React, { Component } from 'react'

export default class AutoSyncCallout extends Component {

  constructor(props) {
    super(props)
    this.state = {
      autoSyncEnabled: false
    }

    RxConversationAPI.get('/conversations/autosync/org/status')
      .checkStatus()
      .map(res => res.response)
      .catch(e => { })
      .subscribe(data => {
        this.setState({ autoSyncEnabled: data.enabled })
      })
  }

  render = () => {
    const { autoSyncEnabled } = this.state
    const { integrationName } = this.props

    return <div>
      {autoSyncEnabled && <InlineWarning
        className="autosync-callout"
        title="Session timeouts are enabled for syncing data to your integrations"
        type="info"
        icon="info"
        copy={<div>
          Data will sync to {integrationName} when the conversation’s session ends. Additionally, users can sync data manually at any time during the conversation. <a href={`${APP_URL}/settings2/conversations/advanced`} target="_blank" rel="noopener noreferrer">View session timeout settings</a>
        </div>}
      />}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/AutoSyncCallout/index.js